import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Globals } from '../../ressources/variables/globals';

@Injectable()
export class UploadCoverService {

  constructor(private httpClient: HttpClient) { }

  envoiFichier(fichierAEnvoyer: File): Promise<string> {
    // const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return new Promise((resolve, reject) => {
      const url = Globals.serverEndpoint + '/upload_cover';
      const formData: FormData = new FormData();
      formData.append('fichier', fichierAEnvoyer, fichierAEnvoyer.name);
      this.httpClient.post(url, formData, {responseType: 'text'}).toPromise()
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
